import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import CookieObj from '../../../common/EducationWidget/helper';
import s from './Timsedition.scss';

class Timsedition extends React.Component {
  constructor() {
    super();
    this.state = {
      showTimesEdition: true,
    };
  }

  componentDidMount() {
    const { citytext } = this.props;
    if (citytext && citytext !== '') {
      this.getTimesEditionStatus();
    }
  }

  handleTimesEditionCloseClick(e) {
    e.preventDefault();
    this.closeTimesEditionPopup();
  }
  // function to close the timesedition nudge
  closeTimesEditionPopup() {
    this.setState({ showTimesEdition: false });
  }

  // closing the nudge after 6 seconds from showing time
  closeTimesEditionAfterSomeTime() {
    setTimeout(() => {
      this.closeTimesEditionPopup();
    }, 6000);
  }

  // function to get timesedition cookie value and set the status to true if cookie not exists
  getTimesEditionStatus() {
    const isCokieExist = CookieObj.get_cookie('clickedtimssnackbar');
    if (isCokieExist && isCokieExist !== 'yes') {
      this.setState({ showTimesEdition: true });
      CookieObj.set_cookie('clickedtimssnackbar', 'yes', 365);
      this.closeTimesEditionAfterSomeTime();
    }
  }

  render() {
    const { citytext } = this.props;
    const { showTimesEdition } = this.state;
    if (citytext && citytext !== '' && showTimesEdition) {
      return (
        <div className={s.timssnackbar}>
          {/* please use this "timssnackbarshow" to show and hide */}
          All <span>{citytext}</span> print stories are available on{' '}
          <span className={s.etimeslogo} />
          <Link
            href="/"
            className={s.timsclosebtn}
            onClick={e => {
              this.handleTimesEditionCloseClick(e);
            }}
          >
            x
          </Link>
        </div>
      );
    }
    return null;
  }
}

Timsedition.propTypes = {
  citytext: PropTypes.string,
};
Timsedition.defaultProps = {
  citytext: '',
};

export default Timsedition;
